<app-input-multi-atom
  [label]="label"
  [active]="isActive"
  [type]="'radio'"
  [value]="value"
  [id]="parentId + '-' + label"
  (valueEmitter)="onValueChange($event)"
></app-input-multi-atom>
